module.exports = __webpack_public_path__ + "img/restaurant-17.d6d70ac0.jpg";